// Unpublished Work © 2022 Deere & Company

import t from 'tcomb';

export const EmailLabel = t.struct({
    emailAddress: t.String
}, {
    defaultProps: {
        emailAddress: ''
    },
    name: 'EmailLabel',
    strict: true
});
